import React from "react";
import { Link } from "react-router-dom";
import "../ChatHeaderSimple.css";

export default function ChatHeaderSimple(props) {
  const { setChatScreenVisable } = props;
  return (
    <div className="chatheader-simple elegant-header-simple">
      <div className="chatheader-close-button">
        <Link
          to="#"
          onClick={() => {
            setChatScreenVisable(false);
          }}
        >
          <span className="close-icon">
            <i className="fas fa-chevron-circle-down"></i>
          </span>
        </Link>
      </div>
      <div className="chatheader-title">
        <span>Destek Hattı</span>
      </div>
    </div>
  );
}
